module.exports = __webpack_public_path__ + "img/box-tissue.b9930c29.svg";